import { render, staticRenderFns } from "./IntegrationsView.vue?vue&type=template&id=571f3c40&scoped=true"
import script from "./IntegrationsView.vue?vue&type=script&lang=js"
export * from "./IntegrationsView.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsView.vue?vue&type=style&index=0&id=571f3c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f3c40",
  null
  
)

export default component.exports